import { z } from "zod";

import { branded } from "@/lib/helpers/branded-helper";
import { anemicReference } from "@/types/backoffice/dto/common/references";
import { eventCategoryDtoSchema } from "@/types/backoffice/dto/event/event-category-dto.ts";
import { operatorDtoSchema } from "@/types/backoffice/dto/person/operator-dto.ts";

export const eventDtoSchema = z.object({
  closureDate: z.coerce.date().nullable(),
  createDateTime: z.coerce.date(),
  date: z.coerce.date(),
  description: z.string().nullable(),
  eventCategory: eventCategoryDtoSchema,
  forecastDate: z.coerce.date().nullable(),
  id: z.number(),
  isOpen: z.boolean().nullable(),
  modificationDate: z.coerce.date(),
  operator: operatorDtoSchema,
  operatorDescription: z.string().nullable(),
  priority: anemicReference(branded.eventPriorityId).nullable(),
  status: anemicReference(branded.eventStatusId).nullable(),
  siteId: z.number(),
});

// @ts-expect-error z.object will return any as type for now, it'll be caught in z.infer later
export const eventTreeSchema = z.object({
  data: eventDtoSchema,
  truncated: z.boolean(),
  children: z.lazy<z.ZodArray<z.infer<typeof eventTreeSchema>>>(() => eventTreeSchema.array()),
});

export type TEventDto = z.infer<typeof eventDtoSchema>;
export type TEventTreeSchema = z.infer<typeof eventTreeSchema>;
